// extracted by mini-css-extract-plugin
export default {"wrapper":"introductionjackbox_wrapper__QQa96","button":"introductionjackbox_button__Z2WQO"};